import { render, staticRenderFns } from "./rightsReport.vue?vue&type=template&id=4080be86"
import script from "./rightsReport.vue?vue&type=script&lang=js"
export * from "./rightsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports